module.exports = __webpack_public_path__ + "img/20230119.2ac4e4b8.png";